import React, { FC } from "react";
import { motion } from "framer-motion";
import { useRouter } from "next/router";
import { DashboardNavbar } from "components/dashboard-navbar";
import { DashboardSidebar } from "components/dashboard-sidebar";
import { useToggleSidebar } from "hooks/useToggleSidebar";
import { getSession } from "utils/auth";
import { isClient } from "utils/generic-utils";
import { DashboardStyleWrapper, MainContent } from "./dashboard-wrapper.style";

interface Props {
   children: any;
   isNew?: boolean;
}

const DashboardWrapper: FC<Props> = ({ children, isNew }) => {
   const { toggle } = useToggleSidebar();
   const router = useRouter();
   const { inSession } = getSession();

   const token = typeof window !== "undefined" && inSession;

   if (typeof window !== "undefined" && !token) {
      router.push({
         pathname: "/signin",
         query: { from: router.pathname, id: router.query.id },
      });
   }

   const variants = {
      hidden: { opacity: 0, x: 0, y: -15 },
      enter: { opacity: 1, x: 0, y: 0 },
      exit: { opacity: 0, x: 0, y: -100 },
   };

   return (
      <DashboardStyleWrapper toggle={toggle}>
         <DashboardNavbar />
         <DashboardSidebar />
         <MainContent toggle={toggle} isNew={isNew}>
            <motion.main
               key={isClient ? router.pathname : ""}
               variants={variants} // Pass the variant object into Framer Motion
               initial="hidden" // Set the initial state to variants.hidden
               animate="enter" // Animated state to variants.enter
               exit="exit" // Exit state (used later) to variants.exit
               transition={{ type: "spring", mass: 1 }} // Set the transition to linear
               className=""
            >
               {children}
            </motion.main>
         </MainContent>
      </DashboardStyleWrapper>
   );
};

export { DashboardWrapper };
